import Modal from "../form/Modal";
import { ModalProps } from "../../../helpers/constants";
import React, { ChangeEvent, FC, FormEvent, useState } from "react";
import Form from "../form/Form";
import InputField from "../form/InputField";
import { validatePassword } from "../../../helpers/utils/Utils";
import {
    useResetPasswordFromProfileMutation,
    useResetPasswordFromWebMutation
} from "../../../features/user/users/usersApi";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { useParams } from "react-router-dom";
import ButtonTray from "../form/ButtonTray";

interface props extends ModalProps {
    setShowRestModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const PasswordExpireConfirmation: FC<props> = ({ show, setShow, setShowRestModal }) => {


    let daysToExpirePassword = JSON.parse(localStorage.getItem("daysToExpirePassword") || "null");

    return (
        <>
            <Modal
                title={"Important! Password Expiration Imminent."}
                show={show}
                setShow={setShow}
                className="w-2/5"
                fields={
                    <>
                        <div className="modal-body">
                            <p className='text-error-1 mb-1'>
                                Your password expires in {daysToExpirePassword} days.
                            </p>
                            <p>Do you want to change it now?</p>
                        </div>

                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "No",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Yes",
                                            onClick: () => {
                                                setShow(false)
                                                setShowRestModal(true)
                                            },
                                            type: "button",
                                        },
                                        buttonType: "button",

                                    }
                                ]}
                                align="end"
                                gap={2}
                            />
                        </div>
                    </>

                }
            />
        </>
    );
};

export default PasswordExpireConfirmation;
